import I18nUtil from '@didi/i18n-util';
import { countryCallingCode } from '@/config/countryConfig/login';
const { getRegion } = I18nUtil;
const host = location.host;

export const is99App = !!host.match('99app.com');

export function getCountry() {
  // let country = getRegion();
  let country = is99App ? 'BR' : 'MX';
  return country;
}

export function getBrand() {
  const brand = is99App ? '99' : 'didi';
  return brand;
}

export function getCallingCode(country) {
  return countryCallingCode[country || getRegion()];
}

export function getPromise(params, data) {
  return new Promise((resolve) => {
    setTimeout(() => {
      resolve(data);
    }, 300);
  });
}
